import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/core/services/product.service';

@Component({
  selector: 'app-categories-letters',
  templateUrl: './categories-letters.component.html',
  styleUrls: ['./categories-letters.component.css']
})
export class CategoriesLettersComponent implements OnInit {

  categories: [];
  public urlHost = "";
  public loading:boolean=true;
  constructor(private productService: ProductService) {
    this.urlHost = environment.urlHostImage;
  }

  ngOnInit() {
    this.getCategories();
  }

  getCategories() {
    this.loading=true;
    this.productService.getCategories().subscribe(
      (data) => {
        this.categories = data;
        this.loading=false;
      },
      (error) => {
        this.loading=false;
        console.log(error);
      }
    );
  }

}
